import { css } from 'styled-components';

/**
 * Stili condivisi della barra del menu principale del frontoffice:
 * permettono ai titoli delle voci di andare a capo mantenendo il
 * centramento verticale quando la larghezza disponibile si riduce.
 */
export const mainMenuTitleWrapStyle = css`
  .main-menu-wrapper-space {
    align-items: stretch;

    .ant-space-item {
      position: relative;
      display: flex;
      align-items: center;
    }
  }

  .main-menu-wrapper-space a {
    display: inline-flex;
    align-items: center;
    min-height: 54px;
  }
`;
